import { Section } from "./Common";
import { fmtNum, fmtShort } from "../lib/fmt";

export default function Trends({ data }) {
  const { weeks, rows } = data.trends;
  const hideCol = (i) => (i < weeks.length - 4 ? "hidden md:table-cell" : "");
  const groups = [];
  rows.forEach((r) => {
    const g = groups.find((x) => x.role === r.role);
    if (g) g.rows.push(r);
    else groups.push({ role: r.role, rows: [r] });
  });
  return (
    <Section id="trends" eyebrow="Tren Mingguan" title="KPI per fungsi, 8 minggu terakhir">
      <div className="overflow-x-auto rounded-2xl border border-brand-line" data-testid="trends-table">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-brand-deep text-xs text-white">
              <th className="px-3 py-2.5 text-left font-bold">KPI</th>
              {weeks.map((w, i) => (
                <th key={w.start} className={`px-2 py-2 text-right font-semibold ${w.current ? "bg-brand" : ""} ${hideCol(i)}`}>
                  <div>M{w.iso}</div><div className="text-[10px] font-normal opacity-80">{fmtShort(w.start)}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {groups.map((g) => [
              <tr key={g.role} className="bg-brand-soft"><td colSpan={weeks.length + 1} className="px-3 py-1.5 text-xs font-extrabold text-brand-deep">{g.role}</td></tr>,
              ...g.rows.map((r) => (
                <tr key={`${r.role}-${r.key}`} className="border-t border-brand-line">
                  <td className="px-3 py-2">{r.label}</td>
                  {r.values.map((v, i) => (
                    <td key={i} className={`px-2 py-2 text-right tabular-nums ${weeks[i].current ? "bg-brand-tint/50 font-extrabold text-brand" : ""} ${v ? "" : "text-[#c2afb0]"} ${hideCol(i)}`}>
                      {v ? fmtNum(v) : "–"}
                    </td>
                  ))}
                </tr>
              )),
            ])}
          </tbody>
        </table>
      </div>
      <p className="mt-2 text-xs text-[#7a6667] md:hidden">Di ponsel ditampilkan 4 minggu terakhir.</p>
    </Section>
  );
}
